import { ExpertiseWidgetStrategy } from '../ExpertiseWidgetStrategy';
import { columnDefs } from './expertiseMakeColumns';
import { WidgetType } from 'widgets/WidgetType';
import { expertiseWidgetStrategyCommon } from 'widgets/expertise/expertiseWidgetStrategyCommon';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { streamConfig } from 'widgets/expertise/store/stream/stream-config';
import Expertise from 'widgets/expertise/Expertise';

export const expertiseMakeWidgetStrategy: ExpertiseWidgetStrategy = {
    title: 'Expertise Make',
    reactComponentType: Expertise,
    reportType: 'DFAMake',
    buildColumnDefs: columnDefs,
    categories: [WidgetCategory.SINGLE_STOCK],
    streamConfigs: [streamConfig(WidgetType.EXPERTISE_MAKE, 'DFAMake')],
    ...expertiseWidgetStrategyCommon,
};
